import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './PartnerBox.module.scss';

export default class PartnerBox extends Component {
  static propTypes = {
    partner: PropTypes.object.isRequired
  };

  render() {
    const {
      partner: { logo }
    } = this.props;

    return (
      <div className={styles.PartnerBox}>
        <div className={styles.ImageBox}>
          <img
            className={styles.Image}
            src={OptimizeImagesService.adjustImageSize(logo)}
            alt="Partner-logo"
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ChoosenCompany/components/PartnerBox/PartnerBox.js